import { Component, OnInit } from '@angular/core';
import { getTenantLetterAssets } from '../../../_shared/utils/letter-assets';
import {
    AlertService,
    ConfirmDialogService,
    ConditionStoreService,
    ConfirmationStoreService, ContactsStoreService,
    DeliveryStoreService,
    FileStoreService,
    IAlertType,
    JobsStoreService,
    NotificationStoreService,
    PersonsStoreService,
    ProjectsStoreService,
    StaffStoreService,
    WarehouseStoreService
} from "../../../_shared/services";
import { WarehouseSelectable } from "../../../_shared/interfaces/warehouse";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {
  StatusButtons,
  Personen,
  JobsList,
  ek,
  Files, Positions, WebserviceResponse, ConditionsList, SingleJob
} from "../../../_shared/interfaces";
import moment from "moment";
import * as XLSX from "xlsx";
import { CurrencyPipe, DatePipe, formatCurrency, JsonPipe, NgForOf, NgIf } from "@angular/common";
import { map } from 'rxjs/operators';
import {
  ClrDatagridModule,
  ClrDropdownModule,
  ClrLoadingModule,
  ClrModalModule,
  ClrTabsModule,
  ClrTooltipModule
} from "@clr/angular";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { UploadComponent } from "../../../core/upload/upload.component";
import {
  angleIcon,
  childArrowIcon,
  ClarityIcons,
  cogIcon, fileIcon, minusCircleIcon, noteIcon, pencilIcon,
  printerIcon,
  twoWayArrowsIcon,
  uploadIcon
} from "@cds/core/icon";
import { JobDetailsOrdersComponent } from "./job-details-orders/job-details-orders.component";
import { JobDetailsDeliveriesComponent } from "./job-details-deliveries/job-details-deliveries.component";
import { JobDetailsRequestsComponent } from "./job-details-requests/job-details-requests.component";
import { JobEditPositionComponent } from "./job-edit-position/job-edit-position.component";
import { JobDetailsOrderlistComponent } from "./job-details-orderlist/job-details-orderlist.component";
import { JobDetailsConfirmationComponent } from "./job-details-confirmation/job-details-confirmation.component";
import { JobDetailsNotificationComponent } from "./job-details-notification/job-details-notification.component";
import { JobDetailsDeliveryComponent } from "./job-details-delivery/job-details-delivery.component";
import { JobDetailsInvoicesComponent } from "./job-details-invoices/job-details-invoices.component";
import { JobDetailsControllingComponent } from "./job-details-controlling/job-details-controlling.component";
import { JobDetailsDocumentsComponent } from "./job-details-documents/job-details-documents.component";
import { CommentFeatureCardComponent } from "../../../core/comment/comment-feature-card/comment-feature-card.component";
import { getTenantStorage } from '../../../_shared/utils/tenant-context';

import { environment as env } from "../../../../environments/environment";
import { filesBaseUrl } from "../../../_shared/utils/rest-url";
import PackageJson from "../../../../../package.json";
import {JobDetailsWarehouseComponent} from "./job-details-warehouse/job-details-warehouse.component";
import { JobDetailsWarehousePositionComponent } from "./job-details-warehouse-position/job-details-warehouse-position.component";


@Component({
  selector: 'app-job-details',
  standalone: true,
  imports: [
    RouterLink,
    NgIf,
    DatePipe,
    ClrDropdownModule,
    NgForOf,
    ClrTabsModule,
    CurrencyPipe,
    ClrModalModule,
    ClrDatagridModule,
    ClrTooltipModule,
    NgxExtendedPdfViewerModule,
    UploadComponent,
    JobDetailsOrdersComponent,
    JobDetailsDeliveriesComponent,
    JobDetailsRequestsComponent,
    JobEditPositionComponent,
    JobDetailsOrderlistComponent,
    JobDetailsConfirmationComponent,
    JobDetailsNotificationComponent,
    JobDetailsDeliveryComponent,
    JobDetailsInvoicesComponent,
    JobDetailsDocumentsComponent,
    JobDetailsControllingComponent,
    JobDetailsWarehouseComponent,
    JobDetailsWarehousePositionComponent,
    ClrLoadingModule,
    CommentFeatureCardComponent
  ],
  templateUrl: './job-details.component.html',
  styleUrl: './job-details.component.sass'
})
export class JobDetailsComponent implements OnInit {
  projectId: string = '';
  jobId: number = 0;
  job: SingleJob = new SingleJob();
  person: Personen | null = null;
  positions: JobsList[] = [];
  foundPositions: Positions[] = [];
  orderFiles: Files[] = [];
  companyId: number = 0;
  loading1: boolean = true;
  loading2: boolean = true;
  selected: JobsList[] = [];
  editPos: number = 0;  // 0 = Anzeige; 1 = Änderungsmodus, 2 = Position ändern
  positionId: number = 0;
  partId: number = 0;
  statusLabel: string = 'label-light-blue';
  statusText: string = '';
  staffFirstName: string = '';
  staffLastName: string = '';
  staffEMail: string = '';
  staffPhone: string = '';
  offerCondition: any = '';
  deliveryCondition: any = '';
  paymentCondition: any = '';
  purchasingSum: number | null = 0;
  sellingSum: number = 0;
  calculation: ek | null = null;
  showFileUpload: boolean = false;
  public showPdf: boolean = false;
  modalContent: string = '';
  modalUrl: string = '';
  devMode: boolean;
  allDelivered: boolean = true;

  // Lieferschein-Auswahl Modal (Serien-/Chargennummern)
  showDeliveryModal: boolean = false;
  deliverySelectables: WarehouseSelectable[] = [];
  selectedDeliveryWarehouseIds: Set<number> = new Set<number>();
  private pendingDeliveryDate: string = '';

  public ppsVersion: string = PackageJson.version;

  basic: boolean = false;

    // Für Ausdruck
    clrModalSize: string = '';

    documentDefinition = getTenantLetterAssets().a4Letter2nd;
    labelDefinition = getTenantLetterAssets().jobLabel;

    private filesDirectory = filesBaseUrl();

    statusButtons: StatusButtons[] = [
        { state: 'open', display: 'Entwurf', label: 'label-info', icon: 'info-circle'},
        { state: 'confirmed', display: 'Auftrag bestätigt', label: 'label-success', icon: 'check-circle'},
        { state: 'standard', display: 'Standard', label: 'alert-info', icon: 'info-circle'},
        { state: 'running', display: 'In Arbeit', label: 'label-warning', icon: 'info-circle'},
        { state: 'invoiced', display: 'Berechnet', label: 'label-danger', icon: 'check-circle'},
        { state: 'finished', display: 'Erledigt', label: 'label-success', icon: 'check-circle'}
    ];

    constructor(
        private jobss: JobsStoreService,
        private condss: ConditionStoreService,
        private contss: ContactsStoreService,
        private delss: DeliveryStoreService,
        private prss: ProjectsStoreService,
        private pss: PersonsStoreService,
        private fss: FileStoreService,
        private stss: StaffStoreService,
        private notss: NotificationStoreService,
        private confss: ConfirmationStoreService,
        private confirmDialog: ConfirmDialogService,
        private warehousess: WarehouseStoreService,
        private router: Router,
        private alertDispatcher: AlertService,
        private route: ActivatedRoute,
    ) {
        this.devMode = env.stages.dev;
        ClarityIcons.addIcons(twoWayArrowsIcon, angleIcon, uploadIcon, printerIcon, cogIcon, childArrowIcon, noteIcon, pencilIcon, minusCircleIcon, fileIcon);
    }

    ngOnInit(): void {
        const params = this.route.snapshot.paramMap;
        this.projectId = params.get('prid') ?? '';
        this.jobId = parseInt(params?.get('jobid') ?? '0', 10);
        this.companyId = parseInt(this.splitProjectNumber(this.projectId, 0));
        this.loading1 = true;
        this.loading2 = true;
        this.editPos = 0;
        this.purchasingSum = 0;
        this.sellingSum = 0;
        this.loadJob(this.projectId, this.jobId);
        this.loadJobsPositions(this.projectId, this.jobId);
        this.calculateEkVk(this.projectId, this.jobId);
        this.searchProjectPositions(this.projectId);
        this.getFilesSet([98], this.projectId, this.jobId);
    }

    ngOnChange(): void {
        this.loading1 = true;
        this.loading2 = true;
        this.loadJob(this.projectId, this.jobId);
        this.loadJobsPositions(this.projectId, this.jobId);
        this.calculateEkVk(this.projectId, this.jobId);
    }

    warnPassiv() {
      this.alertDispatcher.show({
        message: ' ACHTUNG! Passive Komponente(n). ',
        clrAlertType: IAlertType.WARNING
      }, 2000);
      return
    }

    // Anpassung Farbe und Text des Statusbuttons...
    findButtonStatus(orderStatus: string, buttons: StatusButtons[]) {
        return buttons.findIndex(el => el.state === orderStatus)
    };

    splitProjectNumber(projectId: string, substring: number) {
        var splits = projectId.split('.');
        return splits[substring];
    }

    showFileUploader() {
        this.showFileUpload = true;
    }

    async loadJob(projectId: string, jobId: number) {
        this.purchasingSum = 0;
        this.sellingSum = 0;
        this.jobss.getSingleJob(projectId, jobId).subscribe({
            next: data => {
                if (!data || !data.object) {
                    this.alertDispatcher.show({
                      message: 'Keine Orderdaten gefunden!',
                      clrAlertType: IAlertType.WARNING
                    }, 5000);
                    return;
                }

              if (this.devMode) console.log("API Response: ", data);
              if (this.devMode) console.log("Object Type:", Array.isArray(data.object) ? "Array" : "Single Object");

              this.job = Array.isArray(data.object) ? data.object[0] : data.object;

                //this.job = data.object;
                if (this.devMode) {
                  if (this.devMode) console.log("469 - load Job!");
                  if (this.devMode) console.table(this.job);
                }
                // this.calculateEkVk(this.job.project_id, this.job.job_id)
            },
            complete: () => {
                if (!this.job) {
                  this.alertDispatcher.show({
                    message: ' Job-Daten nicht verfügbar. ',
                    clrAlertType: IAlertType.DANGER
                  }, 2000);
                    return;
                }

                // Mitarbeiter personalisieren
                if (this.job.employee_phm) {
                    this.staffStatus(this.job.employee_phm);
                } else {
                  this.alertDispatcher.show({
                    message: ' Der verantwortliche Mitarbeiter wurde nicht ermittelt. ',
                    clrAlertType: IAlertType.WARNING
                  }, 2000);
                }

                // Person ermitteln
                if (this.job.employee_leader) {
                    this.loadPersonData(this.job.employee_leader);
                }

                // Check, ob Rechnungsemfänger VATID vorhanden
                if (this.job.invoice_vat_id.length < 10) {
                  this.alertDispatcher.show({
                    message: ' Bitte UStIDNr. des Rechnungsempfängers prüfen! ',
                    clrAlertType: IAlertType.DANGER
                  }, 5000);
                }

                //Bedingungen ermitteln
                this.deliveryCondition = this.getCondition(this.job.cond_delivery ?? '', 1);
                this.paymentCondition = this.getCondition(this.job.cond_payment ?? '', 2);
                this.offerCondition = this.getCondition(this.job.cond_offer ?? '', 3);

                // Status gestalten
                const statusline = this.findButtonStatus(this.job.status, this.statusButtons);
                this.statusLabel = this.statusButtons[statusline]?.label ?? 'Unbekannt';
                this.statusText = this.statusButtons[statusline]?.display ?? 'Unbekannter Status';

                // CHeck NDA
                this.checkNda(this.projectId)

                this.loading1 = false;
            },
            error: () => {
                return
            }
        });
    }

    private getFilesSet(docType: number[], projectId: string, jobId: number) {
        this.fss.getFilesSet(docType, projectId, jobId, 0).subscribe({
            next: data => {
                if (!data || !data.object || data.object.length === 0) {
                  this.alertDispatcher.show({
                    message: ' Keine Dateien gefunden! ',
                    clrAlertType: IAlertType.WARNING
                  }, 2000);
                    return;
                }
                this.orderFiles = data.object;
            },
            complete: () => {},
            error: () => {
                return}
        })
    }

    // Calculate EK/VK
    calculateEkVk(projectId: string, jobId: number) {
      this.jobss.calculateEK(projectId, jobId).subscribe( {
        next: data  => {
          if (!data || !data.object || data.object.length === 0) {
            this.alertDispatcher.show({
              message: ' EK-Berechnung nicht möglich! ',
              clrAlertType: IAlertType.WARNING
            }, 2000);
              return;
          }
          this.calculation = data.object[0];
          this.purchasingSum = this.calculation.ek;
        },
        complete: () => {
        },
        error: () => {
            return
        }
      });
    }

    searchProjectPositions(projectId: string) {
      this.prss.getPositionsParts(projectId,'0','0').pipe(
        map(res => (res?.object ?? []).filter(p => p.active === true))
      ).subscribe({
        next: (activePositions) => {
          if (!activePositions || activePositions.length === 0) {
            this.alertDispatcher.show({
              message: ' Keine Positionen gefunden. ',
              clrAlertType: IAlertType.WARNING
            }, 2000);
            return;
          }
          this.foundPositions = activePositions;
        },
        error: () => {
          return;
        }
      });
    }

    addRow(position: number, part: number, technicalDrawing: string, positionName: string) {
      if (confirm('Wollen Sie die Position ' + position + '.' + part + ' ' + positionName + ' (' + technicalDrawing + ') dem Job wieder hinzufügen?')) {
        this.jobss.addSingleProjectPosition(this.projectId, this.jobId, position, part)
          .subscribe({
            next: ()  => {
              this.loading2 = true;
              this.loadJobsPositions(this.projectId, this.jobId);
            },
            complete: () => {
              this.loading2 = false;
            },
            error: () => {
              return
            }
          });
      }
    }

    deleteJob(projectId: string, jobId: number) {
        this.jobss.getDeleteJobImpact(projectId, jobId).subscribe({
            next: (impactResponse) => {
                const impact = impactResponse?.object?.[0];
                if (!this.confirmDialog.confirmJobDelete(projectId, jobId, impact)) {
                    return;
                }

                this.jobss.deleteJob(projectId, jobId)
                    .subscribe({
                        next: () => {
                            this.router.navigate(['/project/details/', this.splitProjectNumber(projectId, 0), this.splitProjectNumber(projectId, 1)]);
                        },
                        complete: () => {
                        },
                        error: () => {
                            return
                        }
                    });
            },
            error: () => {
                if (this.confirmDialog.confirmJobDelete(projectId, jobId)) {
                    this.jobss.deleteJob(projectId, jobId)
                        .subscribe({
                            next: () => {
                                this.router.navigate(['/project/details/', this.splitProjectNumber(projectId, 0), this.splitProjectNumber(projectId, 1)]);
                            },
                            complete: () => {
                            },
                            error: () => {
                                return
                            }
                        });
                }
            }
        });
    }

    loadJobsPositions(projectId: string, jobId: number){
        this.sellingSum = 0;
        this.jobss.getJobsPositions(projectId, jobId, '0', '0', '').subscribe({
            next: data2 => {
                if (!data2 || !data2.object || data2.object.length === 0) {
                  this.alertDispatcher.show({
                    message: ' Keine Jobpositionen gefunden. ',
                    clrAlertType: IAlertType.WARNING
                  }, 2000);
                    return;
                }
                this.positions = data2.object;

                for (let x = 0; x < data2.object.length; x++) {
                    if (this.devMode) console.log("430: " + data2.object[x]['selling_price']);

                    // Check, if all positions delivered
                    if (data2.object[x]['pieces_delivered'] < data2.object[x]['number_of_pieces']) this.allDelivered = false;

                    if (data2.object[x].technology) {
                        this.sellingSum += (parseFloat(data2.object[x]['selling_price']));
                    } else {
                        this.sellingSum += (data2.object[x]['number_of_pieces'] * parseFloat(data2.object[x]['selling_price']));
                    }

                    if (this.devMode) console.log("438 Summe: " + this.sellingSum);

                    this.updateBudget(this.sellingSum)
                }
            },
            complete: () => {
                this.loading2 = false;
            },
            error: () => {
                return
            }
        })
    }

    updateBudget(budget: number) {
        this.jobss.updateBudget(this.jobId, this.projectId, budget).subscribe({
            next: data => {},
            complete: () => {
              this.alertDispatcher.show({
                message: ' Projektbudget wurde aktualisiert. ',
                clrAlertType: IAlertType.INFO
              }, 2000);
            },
            error: () => {
                return
            }
        });
    }

    checkNda(projectId: string){
        let contactId: number = parseInt(this.splitProjectNumber(projectId,0));
        let nda: boolean;
        this.contss.getSingleCompany(contactId)
            .subscribe({
                next: company => {
                    if (!company || !company.object || company.object.length === 0) {
                      this.alertDispatcher.show({
                        message: ' Firmendaten konnten nicht geladen werden. ',
                        clrAlertType: IAlertType.WARNING
                      }, 2000);
                        return;
                    }
                    nda = company.object[0].nda ?? false;
                },
                complete: () => {
                    switch (nda){
                        case true:
                          this.alertDispatcher.show({
                            message: ' Bitte beachten: Für diese Firma liegt ein NDA vor! ',
                            clrAlertType: IAlertType.WARNING
                          }, 2000);
                            break;
                        default:
                          this.alertDispatcher.clear();
                            break;
                    }
                },
                error: () => {
                    return
                }
            })
    }

    loadPersonData(person: number) {
        this.pss.getSinglePersons(person)
            .subscribe({
                next: res => {
                    if (!res || !res.object || res.object.length === 0) {
                      this.alertDispatcher.show({
                        message: ' Person nicht gefunden. ',
                        clrAlertType: IAlertType.WARNING
                      }, 2000);
                        return;
                    }
                    this.person = res.object[0]
                },
                complete: () => {},
                error: () => {
                    return
                }
            });
    }

    staffStatus(staffId: number){
        if (this.devMode) console.log('StaffId ist ' + staffId);
        this.stss.getStaffById(staffId)
            .subscribe({
                next: staff => {
                    if (!staff || !staff.object || staff.object.length === 0) {
                      this.alertDispatcher.show({
                        message: ' Mitarbeiter nicht gefunden. ',
                        clrAlertType: IAlertType.WARNING
                      }, 2000);
                        return;
                    }
                    this.staffFirstName = staff.object[0].firstname;
                    this.staffLastName = staff.object[0].lastname;
                    this.staffEMail = staff.object[0].email;
                    this.staffPhone = staff.object[0].phone;
                },
                complete: () => {},
                error: () => {
                    return
                }
            });
    }

    deletePosition(projectId: string, jobId: number, positionId: string, partId: number) {
        this.jobss.deleteJobPosition(projectId, jobId, positionId, partId)
            .subscribe({
                next: () => {
                    this.loadJobsPositions(projectId, jobId);
                },
                complete: () => {
                  this.alertDispatcher.show({
                    message: ' Position ' + positionId + '.' + partId + ' wurde gelöscht. ',
                    clrAlertType: IAlertType.INFO
                  }, 2000);
                },
                error: () => {
                    return
                }
            });
    }

    changeJobStatus(projectId: string, jobId: number, status: number){
        if (confirm('Wollen Sie den Status dieses Jobs wirklich auf "' + this.statusButtons[status].display + '" setzen?')) {
            this.jobss.updateJobStatus(projectId, jobId, this.statusButtons[status].state)
                .subscribe({
                    next: () => {
                        this.loadJob(projectId, jobId);
                        this.loadJobsPositions(projectId, jobId);
                    },
                    complete: () => {
                        this.router.navigate(['/job/details/', projectId, jobId]);
                    },
                    error: () => {
                        return
                    }
                });
        }
    }

    async updateJob(done: boolean) {
        this.editPos = 1;
        await this.loadJob(this.projectId, this.jobId);
        await this.loadJobsPositions(this.projectId, this.jobId);
    }

    updatePositionMode(index: number, positionId: number, partId: number) {
      this.editPos = 2;
      this.positionId = positionId;
      this.partId = partId;
    }

    getCondition(condId: number, condType:number){
      if (condId == 0) {
        this.deliveryCondition = "---";
        this.paymentCondition = "---";
        this.offerCondition = "---";
      } else {
        this.condss.getConditionById(condId, condType)
          .subscribe({
              next: condition => {

                if (!condition?.object) return;
                if (!condition.object.length) return;

                switch (condType) {
                  case 1:
                    this.deliveryCondition = `${condition.object[0].name} (${condition.object[0].text})`;
                    break;
                  case 2:
                    this.paymentCondition = condition.object[0].name;
                    break;
                  case 3:
                    this.offerCondition = condition.object[0].name;
                    break;
                }
              },
              error: () => {
                return
              }
            }
          )}
    }

    createConfirmation(projectId: string, jobId: number){
        if (confirm('Wollen Sie eine Auftragsbestätigung zu diesem Job (' + projectId + '.0006.' + jobId + ') zur weiteren Bearbeitung erstellen?')) {
            this.confss.createConfirmation(projectId, jobId)
                .subscribe({
                    next: (data: WebserviceResponse<boolean>) => {
                        if (!data || data.hasErrors || !data.message) {
                          this.alertDispatcher.show({
                            message: ' Auftragsbestätigung konnte nicht erstellt werden! ',
                            clrAlertType: IAlertType.WARNING
                          }, 2000);
                            return;
                        }
                        // message enthält die confirmationID (muss umgewandelt werden)
                        const confirmationId: number = Number(data.message);

                        if (isNaN(confirmationId)) {
                          this.alertDispatcher.show({
                            message: ' Ungültige ID! ',
                            clrAlertType: IAlertType.WARNING
                          }, 2000);
                            return;
                        }

                        this.router.navigate(['/confirmation/details/', projectId, jobId, confirmationId]);
                    },
                    complete: () => { },
                    error: () => {
                        return
                    }
                });
        }
    }

    createNotification(projectId: string, jobId: number){
        if (confirm('Wollen Sie eine Mitteilung zu diesem Job (' + projectId + '.0006.' + jobId + ') zur weiteren Bearbeitung erstellen?')) {
            this.notss.createNotification(projectId, jobId, 0,61)
                .subscribe({
                    next: (data: WebserviceResponse<boolean>) => {
                        if (!data || data.hasErrors || !data.message) {
                          this.alertDispatcher.show({
                            message: ' Mitteilung konnte nicht erstellt werden! ',
                            clrAlertType: IAlertType.WARNING
                          }, 2000);
                            return;
                        }
                        // message enthält die confirmationID (muss umgewandelt werden)
                        const notificationId: number = Number(data.message);

                        if (isNaN(notificationId)) {
                          this.alertDispatcher.show({
                            message: ' Ungültige ID! ',
                            clrAlertType: IAlertType.WARNING
                          }, 2000);
                            return;
                        }

                        this.router.navigate(['/notification/details/', projectId, jobId, notificationId]);
                    },
                    complete: () => { },
                    error: () => {
                        return
                    }
                });
        }
    }

    onDelete() {
        let choosenPositions = this.selected;
        if (confirm('Wollen Sie die ausgewählten Positionen tatsächlich löschen?')) {
          choosenPositions.forEach(array => {
              if (!array.part) array.part = 0;
              this.deletePosition(this.projectId, this.jobId, array.position.toString(), array.part);
          });

          this.loadJob(this.projectId, this.jobId);
          this.loadJobsPositions(this.projectId, this.jobId);

          this.alertDispatcher.show({
            message: ' Die Positionen wurden gelöscht. ',
            clrAlertType: IAlertType.SUCCESS
          }, 2000);
        }
    }

    createDeliveryNote(projectId: string, jobId: number) {
        const currentDate = moment().format("DD.MM.yyyy");

        // Confirm intent immediately — no waiting for HTTP
        if (!confirm('Wollen Sie einen Lieferschein passend zu diesem Job (' + projectId + '.0006.' + jobId + ') zur weiteren Bearbeitung erstellen?')) {
            return;
        }

        // Check for serialised/batched warehouse items — show selection modal if found
        this.warehousess.getWarehouseSelectable(projectId, undefined, jobId).subscribe({
            next: (res: WebserviceResponse<WarehouseSelectable[]>) => {
                const items = res?.object ?? [];
                // Auswahl anbieten, sobald ueberhaupt Lagerbestand da ist -- frueher
                // nur bei Serien-/Chargennummer, wodurch Inventurzugaenge und
                // unserialisierte Ware nie zur Auswahl standen. Ohne Bestand bleibt
                // es beim Kopieren aller Job-Positionen.
                if (items.length > 0) {
                    this.deliverySelectables = items;
                    this.selectedDeliveryWarehouseIds = new Set(items.map(i => i.warehouse_id));
                    this.pendingDeliveryDate = currentDate;
                    this.showDeliveryModal = true;
                } else {
                    this.doCreateDeliveryNote(projectId, jobId, currentDate, []);
                }
            },
            error: (err: any) => {
                console.error('[createDeliveryNote] getWarehouseSelectable error:', err);
                this.doCreateDeliveryNote(projectId, jobId, currentDate, []);
            }
        });
    }

    toggleDeliveryWarehouseSelection(id: number) {
        if (this.selectedDeliveryWarehouseIds.has(id)) {
            this.selectedDeliveryWarehouseIds.delete(id);
        } else {
            this.selectedDeliveryWarehouseIds.add(id);
        }
    }

    selectAllDeliveryWarehouses() {
        this.selectedDeliveryWarehouseIds = new Set(this.deliverySelectables.map(i => i.warehouse_id));
    }

    confirmDeliveryModal() {
        const ids = Array.from(this.selectedDeliveryWarehouseIds);
        this.showDeliveryModal = false;
        this.doCreateDeliveryNote(this.projectId, this.jobId, this.pendingDeliveryDate, ids);
    }

    private doCreateDeliveryNote(projectId: string, jobId: number, date: string, warehouseIds: number[]) {
        console.log('[doCreateDeliveryNote]', projectId, jobId, date, warehouseIds);
        this.delss.createDeliveryNote(projectId, jobId, date, warehouseIds.length > 0 ? warehouseIds : undefined)
            .subscribe({
                next: (data: WebserviceResponse<boolean>) => {
                    console.log('[doCreateDeliveryNote] response:', data);
                    if (!data || data.hasErrors || !data.message) {
                        this.alertDispatcher.show({ message: 'Lieferschein konnte nicht erstellt werden!', clrAlertType: IAlertType.WARNING }, 4000);
                        return;
                    }
                    const deliveryID: number = Number(data.message);
                    if (isNaN(deliveryID)) {
                        this.alertDispatcher.show({ message: 'Ungültige Lieferschein-ID!', clrAlertType: IAlertType.WARNING }, 4000);
                        return;
                    }
                    this.router.navigate(['/delivery/details/', projectId, jobId, deliveryID]);
                },
                complete: () => {},
                error: (err: any) => {
                    console.error('[doCreateDeliveryNote] error:', err);
                    this.alertDispatcher.show({ message: 'Lieferschein konnte nicht erstellt werden: ' + (err?.message ?? 'Unbekannter Fehler'), clrAlertType: IAlertType.DANGER }, 5000);
                }
            });
    }

    async createMemo(projectId: string, jobId: number) {

        let positions = [];
        let projTable = [[{ text: 'Job' }, { text: projectId + '.0006.' + jobId }]];
        let posTable = [[{ text: 'Pos.'}, { text: 'Bezeichnung' }, { text: 'Zeichnung' }, { text: 'Material'}, { text: 'Anzahl'}, { text: 'Angebot', alignment: 'right'}, { text: 'Lieferdatum', alignment: 'right'}]];

        // create head table
        if (this.job) {
            projTable.push([{ text: 'Bezeichnung '}, { text: this.job.name_project || ''}]);
            projTable.push([{ text: 'Jobdatum '}, { text: moment(this.job.job_date).format("DD.MM.yyyy") }]);
            projTable.push([{ text: 'Lieferdatum '}, { text: moment(this.job.delivery_date).format("DD.MM.yyyy") }]);
            projTable.push([{ text: 'Kunde '}, { text: this.job.company_name.toString() }]);
            if (this.person) {
                projTable.push([{ text: 'Ansprechpartner '}, { text: this.person.salutation + ' ' + this.person.firstname + ' ' + this.person.lastname }]);
            }
            projTable.push([{ text: 'Projektnummer des Kunden '}, { text: this.job.request_id }]);
            projTable.push([{ text: 'Bestellnummer des Kunden '}, { text: this.job.order_id }]);
        }

        positions = this.positions;

        positions.forEach(position => {
            if (!position.technology) {
                switch(position.part) {
                    case 0: {
                        if (position.delivery_date == '2020-01-01') {
                            posTable.push(
                                [ { text: position.position.toString() }, { text: position.name }, { text: position.technical_drawing }, { text: position.material ?? '' }, { text: position.number_of_pieces?.toString() ?? '' }, { text: formatCurrency(Number(position.selling_price), 'de', '', 'EUR').toString(), alignment: 'right' }, { text: '' } ]
                            );
                        } else {
                            posTable.push(
                                [ { text: position.position.toString() }, { text: position.name }, { text: position.technical_drawing }, { text: position.material ?? '' }, { text: position.number_of_pieces.toString() }, { text: formatCurrency(Number(position.selling_price), 'de', '', 'EUR'), alignment:'right' }, { text: moment(position.delivery_date).format("DD.MM.yyyy"), alignment: 'right' }]
                            );
                        }
                        break;
                    }
                    default: {
                        if (position.delivery_date == '2020-01-01') {
                            posTable.push(
                                [ { text: position.position + '.' + position.part, style: 'positionText' } as any, { text: position.name }, { text: position.technical_drawing }, { text: position.material ?? '' }, { text: position.number_of_pieces?.toString() ?? '' }, { text: formatCurrency(Number(position.selling_price), 'de', '', 'EUR'), alignment:'right' }, { text: '' } ]
                            );
                        } else {
                            posTable.push(
                                [ { text: position.position + '.' + position.part, style: 'positionText' } as any, { text: position.name }, { text: position.technical_drawing }, { text: position.material ?? '' }, { text: position.number_of_pieces?.toString() ?? '' }, { text: formatCurrency(Number(position.selling_price), 'de', '', 'EUR'), alignment:'right' }, { text: moment(position.delivery_date).format("DD.MM.yyyy"), alignment: 'right' }]
                            );
                        }
                        break;
                    }
                }
            }
        });

      this.documentDefinition.info.title = 'PPS Job Memo';
      this.documentDefinition.info.subject = 'MEMO ' + this.projectId + '.0006.' + this.jobId;
      this.documentDefinition.info.revison = this.ppsVersion;

      (this.documentDefinition.content[0] as any).columns[0].table.body = projTable;
      (this.documentDefinition.content[0] as any).columns[2].text = '';
      (this.documentDefinition.content[1] as any).table.headerRows = 1;
      (this.documentDefinition.content[1] as any).table.widths = [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ];
      (this.documentDefinition.content[1] as any).table.body = posTable;

      this.generatePdf();
    }

    generatePdf() {
      const documentGenerator = pdfMake.createPdf(this.documentDefinition);

      documentGenerator.getDataUrl((dataUrl: string) => {
        const targetElement = document.querySelector('#documentContainer');
        targetElement!.innerHTML = '';

        if (!targetElement) {
          this.alertDispatcher.show({
            message: ' PDF-Container nicht gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
            return; // Exit the function if the element doesn't exist
        }

        const pdfIframe = document.createElement('iframe');
        pdfIframe.src = dataUrl;
        pdfIframe.width = '100%';
        pdfIframe.height = '100%';
        targetElement.appendChild(pdfIframe);
      })
    }

    async downloadPdf(){
        if (confirm('Wollen Sie das memo zum Projekt ' + 'Memo_' + this.projectId + '.0006.' + this.jobId + '.pdf wirklich herunterladen?')) {
            const documentGenerator = pdfMake.createPdf(this.documentDefinition).download('Memo' + this.projectId + '.0006' + this.jobId + '.pdf');
        }

        await this.safePdf();

      this.alertDispatcher.show({
        message: ' Datei ' + 'Memo_' + this.projectId + '.0006.' + this.jobId + '.pdf wurde herunterladen. ',
        clrAlertType: IAlertType.SUCCESS
      }, 2000);
    }

    archivePdf() {
      if (confirm('Wollen Sie die Datei ' + 'Memo_' + this.projectId + '.0006.' + this.jobId + '.pdf archivieren?')) {
        this.safePdf();
      }

      this.alertDispatcher.show({
        message: ' Datei ' + 'Memo_' + this.projectId + '.0006.' + this.jobId + '.pdf wurde archiviert.',
        clrAlertType: IAlertType.SUCCESS
      }, 5000);
    }

    async printPdf() {
        if (confirm('Wollen Sie die Datei ' + 'Memo_' + this.projectId + '.0006.' + this.jobId + '.pdf ausdrucken?')) {
            pdfMake.createPdf(this.documentDefinition).print();
        }

        await this.safePdf();

      this.alertDispatcher.show({
        message: ' Datei ' + 'Memo_' + this.projectId + '.0006.' + this.jobId + '.pdf wurde an den Drucker übergeben. ',
        clrAlertType: IAlertType.INFO
      }, 2000);
    }

    safePdf() {
      const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);
      documentGenerator.getBlob((blob: Blob) => {
        // Convert Blob to File
        const file = new File(
          [blob], // Blob content
          `Memo_${this.projectId}.0006.${this.jobId}.pdf`, // File name
          { type: blob.type, lastModified: Date.now() } // File metadata
        );

        // Now, send the file instead of the Blob
        this.fss.sendFile(file, 51, 0, this.projectId, this.jobId, '', `Memo ${this.projectId}.0006.${this.jobId}`)
          .subscribe({
              next: (data) => console.log("done"),
              error: (error) => console.error("Error:", error),
              complete: () => console.log("Upload completed")
          });
      });
    }

    printLabel(position: JobsList) {
        this.labelDefinition.content[0].table.body[0][1] = this.projectId + '.0006.' + this.jobId;
        this.labelDefinition.content[0].table.body[1][1] = this.job?.order_id ?? '---';
        this.labelDefinition.content[0].table.body[2][1] = position.name;
        this.labelDefinition.content[0].table.body[3][1] = position.number_of_pieces.toString();
        this.labelDefinition.content[0].table.body[4][1] = position.technical_drawing;
        this.labelDefinition.content[0].table.body[5][1] = position.material;
        this.labelDefinition.content[0].table.body[6][1] = position.heat_nr;
        this.labelDefinition.content[0].table.body[7][1] = position.serial_nr;
        if (confirm('Wollen Sie ein Label zur Position ' + position.position + '.' + position.part + ' ausdrucken?')) {
            pdfMake.createPdf(this.labelDefinition).print();
        }

      this.alertDispatcher.show({
        message: ' Das LAbel wurde an den Drucker übergeben. ',
        clrAlertType: IAlertType.INFO
      }, 2000);
    }

    closeModal(state: boolean) {
        this.showFileUpload = state;
    }

    showModal(fileid: string) {
        const phmToken = getTenantStorage('access_token');
        this.modalUrl = `${this.filesDirectory}/download_file?file_id=${fileid}&token=${phmToken}`;
        this.showPdf = true;
    }

    exportToExcel(data: JobsList[]): void {
        // Dokumentation: https://docs.sheetjs.com
        let positions = data.map((obj: JobsList) => {
            return {
                Position: obj.position,
                Part: obj.part,
                Anzahl: obj.number_of_pieces,
                Bezeichnung: obj.name,
                Zeichnungsnummer: obj.technical_drawing,
                Material: obj.material
            }
        })
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(positions);

        // Passen Sie die Spaltenbreiten an
        const columnWidths = [
            { wpx: 50 }, // Breite für die erste Spalte (in Pixeln)
            { wpx: 50 },
            { wpx: 50 },
            { wpx: 200 },
            { wpx: 200 },
            { wpx: 200 },
        ];
        worksheet['!cols'] = columnWidths;

        const book: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(book, worksheet, 'Werkstattliste');

        if (confirm('Wollen Sie eine Werkstattliste (.xlsx-Datei) für diesen Job herunterladen?')) {
            XLSX.writeFile(book, 'Werkstattliste_' + this.projectId + '.0006.' + this.jobId + '.xlsx');
        }
    }
}
